export default __webpack_public_path__ + "static/media/rae-bg-consumers.3dfa888f.jpg";